export const LIMITED_ADS_SCRIPT_URL =
  "https://pagead2.googlesyndication.com/tag/js/gpt.js";
export const STANDARD_SCRIPT_URL =
  "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
